import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { createPartnersRoutes } from './router/partners-router'
import { Store } from 'vuex'
import { partnersStore } from './store'

export class PartnersModule implements VueModule {
  readonly name = 'partners';
  constructor (private router: VueRouter, private store: Store<any>) {}

  install (Vue: typeof _Vue) {
    const routes = createPartnersRoutes(this.store);
    this.router.addRoutes(routes);
    this.store.registerModule([this.name], partnersStore)
  }
}
